var map = {
	"./aat.svg": 174,
	"./bolt-svgrepo-com.svg": 8084,
	"./buildings-svgrepo-com.svg": 3794,
	"./clock-circle-svgrepo-com.svg": 5854,
	"./dedicated_sup.png": 8022,
	"./dialog-svgrepo-com.svg": 3309,
	"./free_cons.png": 1486,
	"./freeagent.svg": 8453,
	"./global-svgrepo-com.svg": 8784,
	"./hand-heart-svgrepo-com.svg": 1453,
	"./hand-money-svgrepo-com.svg": 5669,
	"./hand-stars-svgrepo-com.svg": 9918,
	"./health-svgrepo-com.svg": 9243,
	"./heart-angle-svgrepo-com.svg": 3375,
	"./heart-lock-svgrepo-com.svg": 2641,
	"./heart-svgrepo-com.svg": 9009,
	"./heart-unlock-svgrepo-com.svg": 6860,
	"./hearts-svgrepo-com.svg": 4606,
	"./help-svgrepo-com.svg": 3868,
	"./help_icon1.jpg": 8070,
	"./help_icon2.jpg": 7649,
	"./help_icon3.jpg": 9604,
	"./history-2-svgrepo-com.svg": 2000,
	"./inbox-line-svgrepo-com.svg": 5558,
	"./laptop-svgrepo-com.svg": 8281,
	"./lightbulb-bolt-svgrepo-com.svg": 2638,
	"./like-svgrepo-com.svg": 4316,
	"./link-minimalistic-2-svgrepo-com.svg": 8470,
	"./lock-password-svgrepo-com.svg": 2244,
	"./lock-svgrepo-com.svg": 9648,
	"./mailbox-svgrepo-com.svg": 8981,
	"./map-arrow-down-svgrepo-com.svg": 782,
	"./medal-ribbon-star-svgrepo-com.svg": 8534,
	"./mention-circle-svgrepo-com.svg": 8314,
	"./messanger_icon.png": 4909,
	"./music-note-svgrepo-com.svg": 2523,
	"./outgoing-call-rounded-svgrepo-com.svg": 1034,
	"./phone-svgrepo-com.svg": 5241,
	"./plain-3-svgrepo-com.svg": 1061,
	"./quickbooks.svg": 6293,
	"./ro_flag.svg": 2270,
	"./ru_flag.svg": 2584,
	"./sage.svg": 1956,
	"./shield-user-svgrepo-com.svg": 1136,
	"./simple_acc.png": 1918,
	"./smile-circle-svgrepo-com.svg": 9916,
	"./tilored_sol.png": 2972,
	"./uk_flag.svg": 2477,
	"./umbrella-svgrepo-com.svg": 3737,
	"./user-block-svgrepo-com.svg": 8800,
	"./user-check-svgrepo-com.svg": 1719,
	"./user-circle-svgrepo-com.svg": 9679,
	"./user-cross-svgrepo-com.svg": 8999,
	"./user-heart-svgrepo-com.svg": 1763,
	"./user-rounded-svgrepo-com.svg": 2956,
	"./user-svgrepo-com.svg": 108,
	"./users-group-rounded-svgrepo-com.svg": 7059,
	"./users-group-two-rounded-svgrepo-com.svg": 5802,
	"./whatsapp_icon.png": 234,
	"./wireless-charge-svgrepo-com.svg": 9096,
	"./xero.svg": 6476
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5125;